module.exports = __webpack_public_path__ + "img/4.6a4d5d9a.png";